import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "data-name": "Layer 1",
  viewBox: "0 0 63.93 35.67"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M0 .25c16.57 9.12 46.71 19.8 27.62 23.95 5.38.91 7.32.31 7.32.31-4.74 3.91-15.78 8.19-22.4 10.55-.66.23-1.88.79.12.56C54.74 25.69 44.93 9.37 63.73.87 64.55.48 62.6.4 61.74.19c-6.07-1.91-11.71 11.6-18.25 13.59-1.88.43-6.87-2.37.68-7.57.65-.45.42-1.1-.5-.74C31.76 8.98 8.72-.73 0 .25Z",
      style: {"fill":"#ef4035","fill-rule":"evenodd"}
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "PY-logo"}) } }